import { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { NotFoundPage } from '@/pages/not-found';
import { useLaunchDarkly } from '@/providers/launchdarkly-provider';
import { LoadingSpinner } from '@/components/loading-spinner';

interface FeatureGuardProps {
  isEnabled: boolean;
  children?: ReactNode;
  fallback?: ReactNode;
}

export const FeatureGuard = ({
  isEnabled,
  children,
  fallback = <NotFoundPage />,
}: FeatureGuardProps) => {
  const { isLoading } = useLaunchDarkly();

  // Show loading spinner while LaunchDarkly flags are being fetched
  if (isLoading) {
    return <LoadingSpinner fullScreen size='lg' />;
  }

  if (!isEnabled) {
    return <>{fallback}</>;
  }

  // If children are provided, render them; otherwise render Outlet for nested routes
  return children ? <>{children}</> : <Outlet />;
};
